import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { RegistrationButtonInterface } from 'src/shared/types/entities/registration-button-interface'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const createRegistrationButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockIdType,
): RegistrationButtonInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.RegistrationButton,
      parentId,
      masterBlockId,
    ),
    buttonType: WebsiteSettingsTypographyTypeEnum.PrimaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
  }
}
